import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { getTopicsClaims } from '../api/getTopics';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { PaginationFilterDto } from '../../../types/Pagination';

type QueryFnTypeTopicsClaims = typeof getTopicsClaims;

type UseTopicsOptionsTopicsClaims = {
    config?: QueryConfig<QueryFnTypeTopicsClaims>;
    filterByUser?: boolean;
};

export const useTopicsClaims = ({ config }: UseTopicsOptionsTopicsClaims = {}) => {
    const filters = useSelector((state: RootState) => state.filters.claims.selectedFilters);
    const filterByUser = useSelector((state: RootState) => state.filters.claims.filterByCurrentUser ?? false);
    const currentUser = useSelector((state: RootState) => state.currentUserInfo.data);

    const paginationFilters: PaginationFilterDto = {
        filters,
        selectedOrganizationalStructureIds: currentUser.selectedOrganizationalStructureIds,
        filterByCurrentUser: filterByUser,
        pageNumber: 1,
        pageSize: 1
    };

    return useQuery<ExtractFnReturnType<QueryFnTypeTopicsClaims>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["topicsClaims", filterByUser, filters, currentUser], 
        queryFn: () => getTopicsClaims(paginationFilters), 
    });
};